(function () {
  const ROOT_SELECTOR = '[data-product-tabs]';

  function initRoot(root) {
    if (!root || root.dataset.ptInit === 'true') return;

    const tabs = Array.from(root.querySelectorAll('[data-pt-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-pt-panel]'));

    if (!tabs.length || !panels.length) return;

    root.dataset.ptInit = 'true';

    let activeIndex = 0;

    // The tab row scrolls sideways on small screens, so a tab picked with the
    // keyboard has to be pulled back into view.
    function revealTab(tab) {
      const row = tab.parentElement;

      if (!row || row.scrollWidth <= row.clientWidth) return;

      const rowBox = row.getBoundingClientRect();
      const tabBox = tab.getBoundingClientRect();

      if (tabBox.left >= rowBox.left && tabBox.right <= rowBox.right) return;

      row.scrollTo({
        left: row.scrollLeft + (tabBox.left - rowBox.left) - (rowBox.width - tabBox.width) / 2,
        behavior: 'smooth',
      });
    }

    function activate(index, focusTab) {
      if (index < 0 || index >= tabs.length) return;

      activeIndex = index;

      tabs.forEach(function (tab, i) {
        const isSelected = i === index;

        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');

        if (isSelected) {
          revealTab(tab);
          if (focusTab) tab.focus();
        }
      });

      panels.forEach(function (panel, i) {
        if (i === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(index, false);
      });

      tab.addEventListener('keydown', function (event) {
        let target = null;

        if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = tabs.length - 1;

        if (target === null) return;

        event.preventDefault();
        activate(target, true);
      });
    });

    const initialIndex = tabs.findIndex(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    });

    activate(initialIndex > -1 ? initialIndex : activeIndex, false);

    // Nutrition-style panels carry one hidden <template> per variant (its own
    // metafield, already falling back to the product-level one server-side).
    // On variant change, swap the matching template's markup into the visible
    // .pt-content so the panel reflects whichever variant is now selected.
    const variantTemplates = Array.from(root.querySelectorAll('template[data-pt-nutrition]'));

    if (variantTemplates.length && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      const unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        const variant = event && event.data && event.data.variant;
        if (!variant) return;

        variantTemplates.forEach(function (template) {
          if (String(template.dataset.ptVariantId) !== String(variant.id)) return;

          const panel = root.querySelector('[data-pt-panel="' + template.dataset.ptNutrition + '"]');
          if (!panel) return;

          let content = panel.querySelector('.pt-content');

          // The initially selected variant may have had no data to render server-side
          // (tab still shown because some other variant has data), so there was
          // nothing to build a .pt-content div around yet. Create it on first use.
          if (!content) {
            content = document.createElement('div');
            content.className = 'pt-content';
            panel.insertBefore(content, panel.firstChild);
          }

          content.innerHTML = template.innerHTML;
        });
      });

      root._ptUnsubscribers = (root._ptUnsubscribers || []).concat(unsubscribeVariantChange);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  function destroyAll(scope) {
    if (!scope) return;

    scope.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      (root._ptUnsubscribers || []).forEach(function (unsubscribe) {
        unsubscribe();
      });

      delete root._ptUnsubscribers;
      delete root.dataset.ptInit;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });

  // The nutrition panel is re-inserted with innerHTML whenever the variant
  // changes, which would drop any listener bound to the select itself (and
  // silently kills an inline <script> shipped with that markup). Delegating from
  // the document keeps the picker working across every swap.
  document.addEventListener('change', function (event) {
    const select = event.target.closest ? event.target.closest('[data-pt-nutrition-select]') : null;

    if (!select) return;

    const scope = select.closest('.pt-content') || select.closest(ROOT_SELECTOR) || document;

    scope.querySelectorAll('[data-pt-nutrition-table]').forEach(function (table) {
      if (table.dataset.ptNutritionTable === select.value) {
        table.removeAttribute('hidden');
      } else {
        table.setAttribute('hidden', '');
      }
    });
  });

  // Link-style tabs jump to another section on the page. Smooth scroll here; the
  // target's scroll-margin-top keeps it clear of the sticky header. A missing
  // target falls back to the browser's normal hash jump.
  document.addEventListener('click', function (event) {
    const link = event.target.closest ? event.target.closest('[data-pt-scroll]') : null;

    if (!link) return;

    const id = decodeURIComponent((link.getAttribute('href') || '').slice(1));
    const target = id ? document.getElementById(id) : null;

    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });

  document.addEventListener('shopify:block:select', function (event) {
    const tab = event.target.matches('[data-pt-tab]') ? event.target : event.target.querySelector('[data-pt-tab]');

    if (tab) tab.click();
  });
})();
